var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"4","offset":"4"}},[_c('v-card',{staticClass:"card",attrs:{"color":"primary"}},[_c('v-card-title',{staticClass:"font-weight-bold justify-center"},[_vm._v("Cambio de contraseña")]),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}})],1)],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }